export const NORMAL = 'normal';
export const MOBILE_FULLSCREEN = 'mobile-fullscreen';
export const MOBILE_SLIDE_UP = 'mobile-slide-up';
export const CONFIRMATION = 'confirmation';
